// src/components/SimpleEditor.tsx
import { TJsonSchemaDocument } from '@commenda/types';
import { PropertiesTable } from './PropertiesTable';
import Card from './ui/Card';
import SectionTitle from './ui/SectionTitle';

export default function SimpleEditor({
  schemaDocument,
  onSchemaDocumentChange,
  showAdditionalProperties = false,
}: {
  schemaDocument: TJsonSchemaDocument;
  onSchemaDocumentChange: (d: TJsonSchemaDocument) => void;
  showAdditionalProperties?: boolean;
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="space-y-4">
        <Card>
          <div className="flex items-center justify-between mb-2">
            <SectionTitle>Properties</SectionTitle>
            <div className="txt-extra-small-regular text-text-placeholder">
              Root is an <span className="txt-extra-small-regular">object</span>{' '}
              with{' '}
              <span className="txt-extra-small-regular">
                additionalProperties: false
              </span>
            </div>
          </div>

          <PropertiesTable
            schemaObjects={schemaDocument.root.properties ?? []}
            onChange={(list) =>
              onSchemaDocumentChange({
                ...schemaDocument,
                root: { ...schemaDocument.root, properties: list },
              })
            }
            showAdditionalProperties={showAdditionalProperties}
          />
        </Card>
      </div>
    </div>
  );
}
